/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const CanvasAreaPosition = core.serialization.enum_(["top", "left", "right", "middle", "bottom"]);
